import { trpc } from '@tencent/tpro_rmonitor_web_server_issue_list';
import { get } from 'lodash-es';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';
type IGetTopIssuesReq = WithTypeCast<trpc.rmonitor.web_server.IGetTopIssuesReq>;
type ITopIssueInfo = WithTypeCast<trpc.rmonitor.web_server.ITopIssueInfo>;
type ISubIssuesPollReq = WithTypeCast<trpc.rmonitor.web_server.ISubIssuesPollReq>;
type ISubIssuesPollRsp = WithTypeCast<trpc.rmonitor.web_server.ISubIssuesPollRsp>;
type ISubIssuesTaskReq = WithTypeCast<trpc.rmonitor.web_server.ISubIssuesTaskReq>;
type ISubIssuesTaskRsp = WithTypeCast<trpc.rmonitor.web_server.ISubIssuesTaskRsp>;
type IGetIssueListReq = WithTypeCast<trpc.rmonitor.web_server.IGetIssueListReq>;
type IGetIssueListRsp = WithTypeCast<trpc.rmonitor.web_server.IGetIssueListRsp>;
export type IIssueInfo = WithTypeCast<trpc.rmonitor.web_server.IIssueInfo>;


/**
 * 产品成员管理
 */
export class IssueService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.IssueListService,
    });
  }

  /**
   * 获取所有角色
   */
  public async getTopIssues(req: IGetTopIssuesReq): Promise<ITopIssueInfo[]> {
    try {
      const rsp = await this.trpcPost('GetTopIssues', req);
      return get(rsp, 'issues', []);
    } catch (e) {
      return [];
    }
  }


  /**
   * 查询二次聚类之后的问题列表
   */
  public async subIssuesPoll(req: ISubIssuesPollReq): Promise<ISubIssuesPollRsp> {
    try {
      return await this.trpcPost<ISubIssuesPollRsp>('SubIssuesPoll', req) || {};
    } catch (e) {
      return {};
    }
  };

  /**
   * 开始拆分
   */
  public async subIssuesTask(req: ISubIssuesTaskReq): Promise<string | null> {
    try {
      const res = await this.trpcPost<ISubIssuesTaskRsp>('SubIssuesTask', req) || {};
      return res?.taskId ?? null;
    } catch (e) {
      return null;
    }
  };

  public async getIssueList(req: IGetIssueListReq): Promise<IGetIssueListRsp> {
    try {
      return await this.trpcPost<ISubIssuesTaskRsp>('GetIssueList', req);
    } catch (e) {
      return {
        total: 0,
        issueList: [],
      };
    }
  }
}


export const issueService = new IssueService();
